import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.mono.lightGray,
    color: theme.palette.mono.primaryDark,
    marginRight: theme.spacing(2),
    cursor: "pointer",
    flexWrap: "nowrap",
  },
  expanded: {
    backgroundColor: theme.palette.colour.primaryBlue,
    color: theme.palette.mono.white,
    width: "auto",
  },
  name: {
    marginLeft: 10,
    lineHeight: "16px",
    fontSize: 12,
  },
}));

export interface TabProps {
  name: string;
  icon: React.ReactNode;
  handleOnClick: () => void;
  expanded?: boolean;
}

const Tab = ({ name, icon, handleOnClick, expanded }: TabProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box
      data-testid={`tab-${name}`}
      onClick={handleOnClick}
      className={clsx(classes.root, expanded && classes.expanded)}
    >
      {icon}
      {expanded && (
        <Typography className={classes.name} data-testid={`expanded-tab-${name}`}>
          {name}
        </Typography>
      )}
    </Box>
  );
};

export default Tab;
